import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const productLinks = [
    { name: 'Makhana', path: '/products/makhana' },
    { name: 'Basmati Rice', path: '/products/basmati-rice' },
    { name: 'Non-Basmati Rice', path: '/products/non-basmati-rice' },
    { name: 'Dehydrated Onion Powder', path: '/products/dehydrated-onion-powder' },
    { name: 'Vegetables', path: '/products/vegetables' },
    { name: 'Fresh Fruits', path: '/products/fresh-fruits' },
  ];

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Products', path: '/products' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const legalLinks = [
    { name: 'Terms & Conditions', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' },
  ];

  return (
    <footer className="bg-gradient-to-b from-[#1e3a5f] to-[#152a47] text-white">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_87e88f53-3494-4c7d-b250-6cc4941bd54b/artifacts/3slnysmo_logo.png" 
              alt="Vista Global Trade" 
              className="h-24 mb-6 brightness-0 invert"
            />
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Connecting the world through premium quality exports from India.
            </p>
            <div className="flex gap-4 mt-6">
              <img src="https://upload.wikimedia.org/wikipedia/en/thumb/e/eb/FSSAI_logo.svg/220px-FSSAI_logo.svg.png" alt="FSSAI" className="h-10 opacity-80 bg-white p-1" />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#c9a961]">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-300 hover:text-white transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#c9a961]">Our Products</h3>
            <ul className="space-y-2">
              {productLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-slate-300 hover:text-white transition-colors text-sm">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#c9a961]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-1 text-slate-400" />
                <span className="text-slate-300 text-sm">
                  313, U.S Complex, Jasola Vihar,<br />Delhi-110076, India
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-slate-400" />
                <a href="mailto:info@vistaglobaltrade.com" className="text-slate-300 hover:text-white transition-colors text-sm">
                  info@vistaglobaltrade.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-slate-400" />
                <a href="tel:+918882062043" className="text-slate-300 hover:text-white transition-colors text-sm">
                  +91 8882062043
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} Vista Global Trade. All rights reserved.
          </p>
          <div className="flex gap-6">
            {legalLinks.map((link) => (
              <Link key={link.path} to={link.path} className="text-slate-400 hover:text-white transition-colors text-sm">
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;